import React, { useState, useEffect } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { put, get } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import DynamicRegionTable from "./DynamicRegionTable";
import ReviewBox from "../../../../Components/Common/ReviewBox";

import { currentYear } from "../../../../utils/generateYearRanges";

const GRI401_1 = ({ hide }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [tabErrors, setTabErrors] = useState({});

  const inputData = {
    fieldName: "newEmployeeHire",
    title:
      "Please provide the total number of new employees hired during the reporting period, categorized by age group, gender, and region.",
    letter: "a.",
    fields: [
      {
        fieldName: "ageGroup",
        title: "Age Group",
        type: "text",
      },
      {
        fieldName: "numberOfEmployees",
        title: "Number of new employees hired",
        type: "number",
        placeholder: "Enter Number",
      },
      {
        fieldName: "rateofHire",
        title: "Rate of new hire",
        type: "percentage",
        placeholder: "Enter Percentage",
      },
    ],
  };

  const inputData1 = {
    fieldName: "employeeTurnover",
    title:
      "What was the total number of employee turnovers within the reporting period, categorized by age group, gender, and region?",
    letter: "b.",
    fields: [
      {
        fieldName: "ageGroup",
        title: "Age Group",
        type: "text",
      },
      {
        fieldName: "turnover",
        title: "Employee turnover",
        type: "number",
        placeholder: "Enter Number",
      },
      {
        fieldName: "rateofTurnover",
        title: "Rate of employee turnover",
        type: "percentage",
        placeholder: "Enter Percentage",
      },
    ],
  };

  const defaultSegments = [
    "Age Under 30 years old",
    "Age 30-50 years old",
    "Age Over 50 years old",
  ];

  const [table, setTable] = useState([]);
  const [table1, setTable1] = useState([]);
  const [data, setData] = useState({});
  const [tabErrors1, setTabErrors1] = useState({});
  const [total, setTotal] = useState({
    male: [{ numberOfEmployees: "" }],
    female: [{ numberOfEmployees: "" }],
  });
  const [total1, setTotal1] = useState({
    male: [{ turnover: "" }],
    female: [{ turnover: "" }],
  });
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/gri/get?type=GRI400&Id=${id}`);
        const res = response.data.data.GRI400?.employeeHire;
        if (response?.data?.data?.year < currentYear - 1)
          setDisabled(true);
        setData(res);
        setTotal({
          male: [res?.maleEmployeeHireTotal],
          female: [res?.femaleEmployeeHireTotal],
        });
        setTotal1({
          male: [res?.maleEmployeeTurnoverTotal],
          female: [res?.femaleEmployeeTurnoverTotal],
        });
      } catch (error) {}
    };

    fetchData();
  }, []);

  useEffect(() => {
    const handleStorage = () => {
      setGriReview(JSON.parse(localStorage.getItem("griReview")));
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  const handleSubmit = async () => {
    if (!disabled) {
      const payload = {
        employeeHire: {
          newEmployeeHire: table?.map((el) => ({
            region: el.region,
            male: el?.table[0],
            female: el?.table[1],
            maleTotal: el?.maleTotal,
            femaleTotal: el?.femaleTotal,
          })),
          employeeTurnover: table1?.map((el) => ({
            region: el.region,
            male: el?.table[0],
            female: el?.table[1],
          })),
        },
        type: "GRI400",
        submitted401_1: true,
      };

      try {
        const res = await put(`/gri/update?Id=${id}`, payload);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        navigate(`/gri/gri400/401-2/${id}`);
      } catch (error) {
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri400/401-2/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      {!hide && <p className={styles.section_heading} style={{ marginBottom: hide ? "-1rem" : "0" }}>401 : Material Used</p>}
      <p className={styles.main_heading} style={{ marginBottom: hide ? "-1.5rem" : "2rem" }}>
        401-1 : New employee hires and employee turnover
      </p>
      {/* Section A */}
      <DynamicRegionTable
        inputData={inputData}
        tables={table}
        setTables={setTable}
        errors={tabErrors}
        setErrors={setTabErrors}
        defaultSegments={defaultSegments}
        parameter={"ageGroup"}
        total={total}
        disabled={disabled}
        setTotal={setTotal}
        data={data}
        hide={hide}
      />
      <DynamicRegionTable
        inputData={inputData1}
        tables={table1}
        defaultSegments={defaultSegments}
        parameter={"ageGroup"}
        setTables={setTable1}
        errors={tabErrors1}
        setErrors={setTabErrors1}
        disabled={disabled}
        total={total1}
        setTotal={setTotal1}
        data={data}
         hide={hide}
      />
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {/* Submit Button */}

        {/* Snackbar for success/error messages */}
      </Box>
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI401_1;
